var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 106,
    viewBox: "0 0 341 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1541 8.44949L0 98.2493H61.591L65.3296 80.2703H28.1025L43.0567 8.44949H18.1541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6578 8.44949L72.6483 98.2493H137.186L140.766 81.1597H99.7686L104.172 60.9571H133.099C132.243 55.2779 132.296 49.4981 133.257 43.8358H107.753L111.966 25.7614H138.453C139.703 22.6554 141.286 19.6945 143.174 16.9308C145.301 13.8003 147.813 10.9508 150.651 8.44949H91.6578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.253 98.2493L239.14 92.5634C246.168 84.3956 251.045 74.5936 253.325 64.0514C255.605 53.5093 255.216 42.5626 252.194 32.2098L257.231 8.29065H287.266L305.579 70.4549L318.252 8.54478H341.063L322.054 98.3446H292.431L273.421 36.0851L260.748 98.2493H238.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.327 104.444C221.656 104.444 244.621 81.4186 244.621 53.0159C244.621 24.6132 221.656 1.58826 193.327 1.58826C164.998 1.58826 142.033 24.6132 142.033 53.0159C142.033 81.4186 164.998 104.444 193.327 104.444Z",
    fill: "#BF2B23",
    stroke: "#BF2B23",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.469 29.9545L173.177 25.8568L186.452 1.08004C191.853 0.469506 197.311 0.60843 202.674 1.49295L214.079 24.7767L240.408 30.3674C241.606 32.8997 242.602 35.5232 243.386 38.2134C244.123 40.7892 244.695 43.41 245.097 46.0594L227.418 63.816C228.4 72.5197 229.414 81.1915 230.396 89.8634C228.319 92.0584 226.026 94.0379 223.553 95.7717C221.397 97.2929 219.118 98.6317 216.741 99.7741L193.327 88.4022L170.357 99.9964C168 98.8058 165.724 97.458 163.546 95.9623C161.304 94.3784 159.186 92.6263 157.209 90.721L161.074 63.5302C154.738 56.9654 148.401 50.3794 142.065 43.7723C142.442 41.3995 143.014 39.062 143.776 36.7839C144.503 34.4436 145.403 32.1609 146.469 29.9545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.912 33.7663H207.775L216.361 60.3219L193.708 77.5385L170.294 60.3219L178.912 33.7663Z",
    fill: "#BF2B23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 341,
    height: 106,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.445c0c9725fd138074d330a05c7278f9.svg";
export { ForwardRef as ReactComponent };